export default {
  title: {
    regular: 'Zwykłe modyfikatory produktów',
    meal: 'Utwórz pozycję zestawu',
    upsell: 'Utwórz grupę upsell',
  },
  description: {
    regular:
      'Wybierz modyfikatory, które znajdą się w nowej grupie modyfikatorów, jeśli istnieją już w innych grupach. Możesz też utworzyć grupę i dodać modyfikatory później.',
    meal: 'Wybierz produkty do zestawu. Jeśli produkty jeszcze nie istnieją, utwórz je na stronie „Zarządzaj menu". Pamiętaj, aby przypisać pozycję zestawu do odpowiednich produktów w sekcji „Modyfikatory" kreatora produktu.',
    upsell:
      'Wybierz produkty do grupy upsell. Jeśli produkty jeszcze nie istnieją, utwórz je na stronie „Zarządzaj menu". Pamiętaj, aby przypisać pozycję upsell do odpowiednich produktów w sekcji „Modyfikatory" kreatora produktu.',
  },
  fields: {
    name: {
      label: 'Nazwa',
      placeholder: 'Wpisz nazwę grupy modyfikatorów',
    },
    max_quantity: {
      label: 'Maks. ilość',
      placeholder: 'Maks. ilość modyfikatorów',
    },
    is_required: {
      label: 'Wymagane',
    },
  },
  labels: {
    visible: 'Widoczne',
    hidden: 'Ukryte',
    multiply: 'Mnożalne',
  },
  buttons: {
    save: 'Zapisz',
    close: 'Zamknij',
  },
  toasts: {
    modifier_group_got_created: 'Grupa modyfikatorów została utworzona',
    modifier_group_got_updated: 'Grupa modyfikatorów została zaktualizowana',
  },
};
